import React, { useState } from "react";
import {
  Button,
  IconButton,
  Card,
  CardActions,
  CardContent,
  Collapse,
  CardHeader,
  Grow,
  CircularProgress,
  LinearProgress
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import SaveIcon from "@material-ui/icons/Save";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { useForm } from 'react-hook-form';
import CourseService from '../../../../../services/CoursesService';
import { datetimeToString } from '../../../../../utils/datetime';
import actionsTopButtonStyles from '../../../../../screens/components/App/customMaterialStyles';
import { useDispatch, useSelector } from "react-redux";
import { showSnackBar } from "../../../../../redux/actions/ui";
import CourseForm from "./CourseForm";
import { showConfirmDialog } from "../../../../../redux/actions/uiConfirmDialog";
import { parseOccurences } from "../../../../../utils/occurrences";


const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: "1em"
  },
  collapse: {
    borderTop: "1px solid"
  }
}));

function CourseItem(props) {
  const { loading = false, listTeachers, isExpanded, page } = props;   
  const dispatch = useDispatch();
  const { user } = useSelector( state => state );
  
  const { id, name, modified_datetime } = props.data || {};

  const classes = useStyles();
  const actionsTopButtonStylesClasses = actionsTopButtonStyles();

  const [expanded, setExpanded] = useState(isExpanded);
  const [isEditableForm, setIsEditableForm] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const { register, errors, handleSubmit, control } = useForm({
    validateCriteriaMode: "all",
    mode: "onChange"
  });
  
  const handleExpandClick = () => {
    const isExpanded = !expanded;
    setExpanded(isExpanded);
  };
  
  const handleClickOpenDialogRemove = () => {
    dispatch(
      showConfirmDialog(
        "Remove this course ?", 
        "You won't be able to revert this!", 
        handleOnDelete
      )
    );
  };

  const handleOnDelete = async () => {    
    setIsLoadingSubmit(true);
    try{
      const courseId = id;      
      await CourseService.deleteCourse(courseId);         
      // handleCloseDialogRemove();
      props.removeCourse(courseId);
    }catch (error) {
      setIsLoadingSubmit(false);
    }  
  }
  
  const editCourse = async data => {    
    console.log(data);
    const dataToUpdate = {...data, id};
    dataToUpdate.occurrences = parseOccurences(dataToUpdate.occurrences);
    dataToUpdate.office_hours = parseOccurences(dataToUpdate.office_hours);
    setIsLoadingSubmit(true);
    try{
      await CourseService.updateCourse(dataToUpdate);
      setIsLoadingSubmit(false);      
      dispatch(showSnackBar("Successfully edited!"));
      props.updateCourseFromList(id, dataToUpdate);
    }catch (error) {
      setIsLoadingSubmit(false);
      dispatch(showSnackBar("An error occurred!", 'error'));
    }  
  };

  return (
    <Card className={classes.root}>
      {/* Course header */}
      <CardHeader
        action={
          <React.Fragment >
            {expanded && (
              <React.Fragment>
                <Grow in={expanded} {...(expanded ? { timeout: 1000 } : {})}>                
                  <IconButton 
                    aria-label="edit-course" 
                    className={clsx(actionsTopButtonStylesClasses.actionsTopButtons, {
                      [actionsTopButtonStylesClasses.actionsTopButtonsSelected]: isEditableForm
                    }) } 
                    onClick={() => setIsEditableForm(!isEditableForm) }>
                    <EditOutlinedIcon />
                  </IconButton>
                </Grow>    
                {user && user.data.profile === 'manager' ?
                <Grow in={expanded} {...(expanded ? { timeout: 500 } : {})} >
                  <IconButton aria-label="delete-course" className={actionsTopButtonStylesClasses.actionsTopButtons} onClick={handleClickOpenDialogRemove}>
                    <DeleteForeverOutlinedIcon />
                  </IconButton>
                </Grow>
                : null}
              </React.Fragment>
            )}

            {loading ?
              <Skeleton
                variant="circle"
                width={50}
                height={50}
                style={{ marginBottom: 0 }}
              />
              :
              <IconButton
                className={clsx(actionsTopButtonStylesClasses.expand, {
                  [actionsTopButtonStylesClasses.expandOpen]: expanded
                }, actionsTopButtonStylesClasses.actionsTopButtons)}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="Expand"
                data-testid="expand-course"
              >
                <ExpandMoreIcon />
              </IconButton>              
            }
          </React.Fragment>
        }
        title={
          loading ? (
            <Skeleton
              variant="rect"
              width={180}
              height={20}
              style={{ marginBottom: 6 }}
            />
          ) : (
            name
          )
        }
        subheader={
          loading ? (
            <Skeleton variant="rect" width={210} height={10} />            
          ) : (
            `Last edit: ${datetimeToString(modified_datetime, "MM-DD-YYYY HH:mm")}`
          )
        }
      />
      
      {/* Loading */}
      {isLoadingSubmit && <LinearProgress />}      

      {/* Body forms */}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent className={classes.collapse}>
          <CourseForm isEditableForm={isEditableForm} data={props.data} formConfig={ {register, errors, handleSubmit, control} } listTeachers={listTeachers} allowEditUsers={true} page={page}>
            {/* Action Buttons to save */}
            {isEditableForm && (
              <CardActions className={actionsTopButtonStylesClasses.saveAction} >
                <Button
                  variant="outlined"
                  type="submit"
                  disabled={isLoadingSubmit} 
                  onClick={() => setIsEditableForm(false)}>
                  Cancel
                </Button>
                <Button
                  variant="outlined"
                  color="primary"     
                  type="submit"            
                  onClick={handleSubmit(editCourse)}
                  disabled={isLoadingSubmit} 
                  startIcon={
                    isLoadingSubmit ? <CircularProgress size={24}/> : <SaveIcon />
                  }>
                  Save
                </Button>
              </CardActions>
            )} 
          </CourseForm>
        </CardContent>
      </Collapse>
      
    </Card>
  );
}

export default CourseItem;
